export class Report {
  id: number | null;
  uid: string | null;
  name: string;
  type: string;
  status: string;

  constructor(report: IReportDTO) {
    this.id = report.id;
    this.uid = report.uid;
    this.name = report.name;
    this.type = report.type;
    this.status = report.status;
  }
}

export interface IReportDTO {
  id: number | null;
  uid: string | null;
  name: string;
  type: string;
  status: string;
}
